import { useCallback, useEffect, useState } from 'react';
import { HISTORY_PAGE_SIZE, rangeBounds, type HistoryRange } from './lib';

/** Page, date range and open round for a history popup. Each game keeps
    its own query hook, since each store owns its API slice. */
export function useHistoryState(open: boolean) {
  const [page, setPage] = useState(0);
  const [range, setRange] = useState<HistoryRange>('ALL');
  const [selectedId, setSelectedId] = useState<string | null>(null);

  // Start each open on page one, unfiltered, with nothing selected.
  useEffect(() => {
    if (open) {
      setPage(0);
      setRange('ALL');
      setSelectedId(null);
    }
  }, [open]);

  const goToPage = useCallback((next: number) => {
    setPage(next);
    // The selected row is about to be replaced.
    setSelectedId(null);
  }, []);

  const changeRange = useCallback((next: HistoryRange) => {
    setRange(next);
    setPage(0);
    setSelectedId(null);
  }, []);

  return { page, range, selectedId, setSelectedId, goToPage, changeRange };
}

export interface HistoryQueryArgs {
  userId: number;
  gameId: string;
  page: number;
  range: HistoryRange;
}

/** The `/history` params for one page. */
export const historyQueryArgs = ({
  userId,
  gameId,
  page,
  range,
}: HistoryQueryArgs) => ({
  userId,
  gameId,
  page,
  limit: HISTORY_PAGE_SIZE,
  ...rangeBounds(range, new Date()),
});
